import { render } from "./AddProductEntitlement.vue?vue&type=template&id=e7a72614"
import script from "./AddProductEntitlement.vue?vue&type=script&lang=js"
export * from "./AddProductEntitlement.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__